import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import checkGreenIcon from '../../../assets/policy/check-green.svg';

import { PET_DEMOS_SPECIES } from '../../../constants';

import styles from './PetsCounter.module.css';

const PetsCounter = ({
  selectedPets = [],
  specietype = PET_DEMOS_SPECIES.dog,
  totalPets = 0,
}) => {
  const { t } = useTranslation('petDemos');
  // TODO: Replace with real logic to check if pets match removal dates
  const isRemovable = true;

  const { count, isComplete } = useMemo(() => {
    const filteredPets = selectedPets.filter(
      (pet) => pet.Specie === specietype,
    );
    const filteredCount = filteredPets.length;
    const completed = filteredCount === totalPets && totalPets > 0;

    return {
      count: filteredCount,
      isComplete: completed,
    };
  }, [selectedPets, specietype, totalPets]);

  const showCheckmark = isComplete && isRemovable;

  const specieLabel = t(`${specietype.toLowerCase()}`, { count: totalPets });

  return (
    <span
      className={`${styles.counter} ${
        showCheckmark ? styles.complete : ''
      }`}
    >
      {`${specieLabel} ${count}/${totalPets}`}

      {showCheckmark && (
        <img
          alt=""
          className={styles.checkmark}
          src={checkGreenIcon}
        />
      )}
    </span>
  );
};

export { PetsCounter };
